module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-UltraBold.42c1b07.eot";